import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { hasError: boolean }

// ponytail: minimal error boundary for chunk load failures only.
// Resets state on retry → React re-renders children → re-triggers lazy import.
// No page reload needed. Upgrade path: add reload button if retry fails twice.
export class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() { return { hasError: true }; }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '200px', gap: '16px' }} role="alert">
          <p>Failed to load page. Check your connection and try again.</p>
          <button onClick={this.handleRetry} style={{ padding: '8px 16px', cursor: 'pointer', borderRadius: '4px', border: '1px solid #d1d5db', background: '#f9fafb' }}>
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
